// initial state
const state = {
  key: null,
  fonte: 'interno',
  folder: 'root',
  uploadTask: {},
  breadCrumbs: {},
  stepSelezionato: {},
  nodoInserimento: 'Interno',
  selectorPath: ['tipologie', 'marche', 'modelli', 'ricambi', 'n/d']
}

// getters
const getters = {
  // eslint-disable-next-line no-undef
  uploadTask: state => state.uploadTask,
  breadCrumbs: state => state.breadCrumbs,
  stepSelezionato: state => state.stepSelezionato,
  nodoInserimento: state => state.nodoInserimento,
  // costruire il puntatore in base alla fonte dello step selezionato 
  pointer(state, getters, rootState) {
    return 'Utenti/' + rootState.loginStates.userDettails.uid + '/'
  },
  pointerChunk(state, getters, rootState) {
    return 'Utenti/' + rootState.loginStates.userDettails.uid + '/chunk_img'
  },
  pointerExt(state, getters, rootState) {
    return 'Utenti/' + rootState.fbPointers.pointerExt
  }
}

// TODO : ON INIT IF CHUNK CANCELL DB ITEM E STORAGE IMG

// actions
const actions = {
  generateKey({ commit, state, getters, actions }, payload) {
    var pointer = getters.pointer + state.stepSelezionato.hook
    var key = this.databaseOps.db.ref(pointer).push().key
    return key
  },
  //  @click.native="inEdit ? $refs.imgChange.click() : prova()"
  clearChunk({ commit, state, getters, actions }, payload) {
    // chiamato in -> selettoreNewElement.vue
    // elimina chunk da db e storage
    // console.log('clearChunk' + getters.pointerChunk)
    this.databaseOps.db.ref(getters.pointerChunk).on('value', (snapshot, prevChildKey) => {
      this.databaseOps.db.ref(getters.pointerChunk).off()
      if (snapshot.exists()) {
        snapshot.forEach((itemSnap) => {
          const item = itemSnap.val()
          // console.log('chunk ce' + item.value)
          this.databaseOps.db.ref(getters.pointerChunk).child(item.value).remove()
          this.databaseOps.storage.ref(getters.pointer + item.percorso).child(item.value).delete()
        })
      }
    })
  },
  preloadImg({ commit, state, getters, actions }, payload) {
    var self = this
    var metadata = {
      contentType: payload.file.type,
      Software: 'Jestionale'
    }
    var key = payload.key
    var pointer = getters.pointer + state.stepSelezionato.hook
    if (state.stepSelezionato.fonte === 'esterno') {
      // per eliminare eredità commentare riga sotto.
      //pointer = 'Altro_mondo/' + state.stepSelezionato.hook
    }
    var uploadTask = this.databaseOps.storage.ref(pointer).child(key).put(payload.file, metadata)
    // console.log('carico immagine in' + pointer)
    uploadTask.on(
      'state_changed', // or 'state_changed'
      (snapshot) => {

      },
      (error) => {
        console.log(error)
      },
      () => {
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          let obj = { percorso: state.stepSelezionato.hook, value: key }
          // sistemare regola firebase che previene sovrascrittura intero nodo ricambi
          self.databaseOps.db.ref(getters.pointerChunk).child(key).set(obj, (error) => {
            if (error) console.log('Errore salvataggio chunk')
            else {
              console.log('Chunk registrato.')
            }
          })
        })
      }
    )
    state.uploadTask = uploadTask
  },
  loadImg({ commit, state, getters, actions }, payload) {
    var metadata = {
      contentType: payload.file.type,
      Software: 'Jestionale'
    }
    var pointer = getters.pointer + state.stepSelezionato.hook
    if (state.stepSelezionato.fonte === 'esterno') {
      pointer = 'Altro_mondo/' + state.stepSelezionato.hook
    }
    var uploadTask = this.databaseOps.storage.ref(pointer).child(payload.ricambio.id).put(payload.file, metadata)
    console.log('carico immagine in' + pointer)
    uploadTask.on(
      'state_changed', // or 'state_changed'
      (snapshot) => {

      },
      (error) => {
        console.log(error)
      },
      () => {
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          // console.log(downloadURL)
          payload.ricambio.tempImg = downloadURL
          // ++++++++++++++++++++++++++++++++++++++++++
        })
      }
    )
    state.uploadTask = uploadTask
  },
  newElement({ commit, state, getters, actions, dispatch }, payload) {
    var pointer = getters.pointer
    var self = this
    var element = {}
    var key = payload.key
    var paths = {}
    element = {
      id: key,
      img_name: key,
      fonte: 'interno',
      category: state.stepSelezionato.id,
      hook: state.selectorPath[state.selectorPath.indexOf(state.stepSelezionato.hook) + 1],
      parent: state.stepSelezionato.hook,
      path: state.stepSelezionato.path.concat({ [state.stepSelezionato.hook]: state.stepSelezionato.id, "fonte": state.stepSelezionato.fonte }),
      timestamp: Date.now(),
      _timestamp: -Date.now()
    }
    Object.assign(element, payload)
    if (payload.key === null) {
      dispatch('generateKey').then(response => {
        element.id = response
        element.key = response
        element.path = state.stepSelezionato.path.concat({ [state.stepSelezionato.hook]: state.stepSelezionato.id, "fonte": state.stepSelezionato.fonte })
        delete element.img_name;
        delete element.key;
        paths[element.parent + '/' + response] = element
        paths['labels/' + response] = element.value
        self.databaseOps.db.ref(getters.pointer).update(paths, function (error) {
          self.databaseOps.db.ref(getters.pointerChunk).child(response).remove()
          if (error) {
            console.log('Errore creazione elemento:', error)
          }
        })
      })
        .catch(err => {
          console.log(err);
        });
    }
    else {
      paths[element.parent + '/' + key] = element
      paths['labels/' + key] = element.value
      this.databaseOps.db.ref(getters.pointer).update(paths, function (error) {
        self.databaseOps.db.ref(getters.pointerChunk).child(key).remove()
        if (error) {
          console.log('Errore creazione elemento:', error)
        }
      })
    }
  },
  removeElement({ commit, state, getters, actions }, payload) {
    // rimuove elemento quadratino, alias ed eventuale immagine.
    this.databaseOps.db.ref(getters.pointer + payload.parent).child(payload.id).remove()
    this.databaseOps.db.ref(getters.pointer + payload.parent + '/alias').child(payload.id).remove()
    this.databaseOps.db.ref(getters.pointer + '/labels').child(payload.id).remove()
    this.databaseOps.storage.ref(getters.pointer + payload.parent).child(payload.id).delete()
    this.databaseOps.db.ref(getters.pointer).child(payload.id).on('child_removed', function (snapshot) {
      var deletedChild = snapshot.val()
      console.log(deletedChild)
    })
  },
  updateElement({ commit, state, getters, actions }, payload) {
    // aggiorna  children , crea alias e aggiorna label.
    // var payload = { item: item , value : value }
    var self = this;
    var item = payload.item
    var value = payload.value
    var updates = {};
    updates['labels/' + item.id] = value
    updates[item.parent + "/" + item.id + "/" + 'value'] = value;
    updates[item.parent + "/" + 'alias/' + item.id + '/value'] = value;
    if (item.fonte === "interno") {
      this.databaseOps.db.ref(getters.pointer).update(updates, (error) => {
        if (error) console.log("Errore creazione/aggiornamento aliasValue");
        else {
            console.log('Rinomina ok')
        }
      });
    } else console.log("Fonte esterna o non definita");
  }
}

// mutations
const mutations = {
  setKey(state, value) {
    state.key = value
  },
  setFolder(state, value) {
    state.folder = value
  },
  setStepSelezionato(state, obj) {
    state.stepSelezionato = obj
  },
  setBreadCrumbs(state, obj) {
    state.breadCrumbs = obj
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
